export default function AboutGleice() {
  const results = [
    { icon: "ri-line-chart-line", value: "+35%", label: "Aumento de faturamento em 90 dias" },
    { icon: "ri-percent-line", value: "+20pts", label: "Melhoria em índices de sell through" },
    { icon: "ri-box-3-line", value: "-40%", label: "Redução de rupturas e estoques parados" },
    { icon: "ri-group-line", value: "+3.000", label: "Vendedores e gestores treinados" },
    { icon: "ri-store-2-line", value: "28 anos", label: "De experiência real no varejo" },
    { icon: "ri-map-pin-2-line", value: "Todo Brasil", label: "Lojas e marcas atendidas" },
  ];

  const brands = [
    "H. Stern", "Arezzo", "Daslu", "7 For All Mankind", "Lee", "Halston", "Paige"
  ];

  return (
    <section
      id="quem-somos"
      className="py-20 px-6 md:px-16 bg-[#faf9f7] border-t border-gray-100"
    >
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#b8962e] text-xs tracking-[0.3em] uppercase font-medium mb-4 border border-[#b8962e]/40 px-3 py-1">
            Quem Somos
          </span>
          <h2 className="text-3xl md:text-4xl font-light text-black tracking-tight">
            A história por trás do <span className="font-semibold">Método CAT</span>
          </h2>
        </div>

        {/* Main content: photo + text */}
        <div className="flex flex-col lg:flex-row gap-14 items-start mb-16">

          {/* Photo block */}
          <div className="lg:w-80 shrink-0 flex flex-col items-center gap-4">
            <div className="w-64 h-80 rounded-lg overflow-hidden border border-[#b8962e]/20">
              <img
                src="https://storage.readdy-site.link/project_files/6403a48a-1e3d-4a7f-80a1-63b2ebe85030/47b68a2a-669a-4028-a55a-db99149e15a8_Gleice.png?v=b1ce88b4ce58c92c6097cac96816f8c8"
                alt="Gleice Lyra — fundadora da Clientizah"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="text-center">
              <p className="text-sm font-semibold text-black tracking-tight">Gleice Lyra</p>
              <p className="text-xs text-[#b8962e] tracking-widest uppercase mt-0.5">Fundadora</p>
            </div>

            {/* Brands */}
            <div className="mt-2 text-center">
              <p className="text-[10px] tracking-[0.2em] uppercase text-gray-400 mb-2">Marcas onde atuou</p>
              <div className="flex flex-wrap justify-center gap-1.5">
                {brands.map((b) => (
                  <span
                    key={b}
                    className="text-[10px] border border-gray-200 text-gray-500 px-2 py-0.5 rounded-full whitespace-nowrap"
                  >
                    {b}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Text content */}
          <div className="flex-1 space-y-5 text-gray-600 text-[15px] leading-relaxed">
            <p>
              Olá, pessoal! Eu sou a <strong className="text-black font-semibold">Gleice Lyra</strong>, da{" "}
              <strong className="text-black font-semibold">Clientizah</strong> — empresa especializada em gestão, vendas
              e experiência do cliente, hoje presente em lojas por todo o Brasil, ajudando marcas e
              multimarcas a aumentar seu desempenho e ter mais rentabilidade.
            </p>

            <p className="text-[#7a6420] font-medium border-l-4 border-[#b8962e]/50 pl-4">
              De nada adianta vender mais se de fato não entrar mais dinheiro no caixa da loja.
            </p>

            <p>
              Muitos de vocês ainda não me conhecem, então quero contar rapidamente como tudo começou — e talvez
              você se identifique, de alguma forma, na minha história.
            </p>

            <div className="border-l-2 border-[#b8962e]/40 pl-5 italic text-gray-500">
              "Eu não tive nada fácil. Nada veio de mão beijada. O que me fez agir foi o desespero."
            </div>

            <p>
              Minha família sempre foi minha base. Tive uma infância estruturada, mas nunca com luxos — três filhos,
              pai engenheiro e mãe professora, tudo regrado. Até que a empresa do meu pai faliu. Ver meus pais
              desesperados me ensinou cedo que{" "}
              <strong className="text-black">dinheiro é liberdade e segurança</strong>. E foi aí que decidi trilhar
              meu próprio caminho.
            </p>

            <p>
              Fui modelo, operadora de telemarketing, estagiária de produtora de filmes. Aos 17 anos, passei na
              faculdade, me mudei para São Paulo e comecei minha jornada profissional. O que aparecia, eu fazia.
              Até que ouvi uma frase que mudou tudo:
            </p>

            <div className="bg-[#b8962e]/8 border border-[#b8962e]/20 rounded-lg px-6 py-4">
              <p className="text-[#7a6420] font-semibold text-base italic">
                "Você é uma excelente vendedora. Siga essa área."
              </p>
              <p className="text-gray-500 text-sm mt-1">E segui.</p>
            </div>

            <p>
              Entrei — depois de muita insistência — na marca que eu mais amava. Em menos de 1 ano, com apenas{" "}
              <strong className="text-black">19 anos</strong>, assumi a supervisão de{" "}
              <strong className="text-black">30 lojas</strong>, liderando equipes, metas e operações. Trabalhava
              todos os dias, finais de semana e feriados.
            </p>

            <p>
              Dali em diante, minha carreira acelerou. Trabalhei em marcas como{" "}
              <strong className="text-black">H. Stern, Arezzo, Daslu</strong> e em grifes internacionais como{" "}
              <strong className="text-black">7 For All Mankind, Lee, Halston, Paige</strong>, entre outras.
              Aprendi a vender com os melhores profissionais do mercado, me especializei com pós-graduação, cursos,
              certificações — e sigo estudando todos os dias.
            </p>

            <p>
              E graças ao meu trabalho, realizei meus sonhos: comprei o{" "}
              <strong className="text-black">carro dos meus sonhos</strong>, presenteei minha mãe, levei meu
              filho para a Europa e conquistei estabilidade financeira sendo vendedora.
            </p>

            <p>
              Foi assim que nasceu a <strong className="text-black">Clientizah</strong>: fruto de quase três décadas
              dentro do varejo, franquias e multimarcas — na prática, no chão de loja e nos bastidores estratégicos.
            </p>

            <p className="text-black font-medium">
              Hoje, meu objetivo é compartilhar tudo o que aprendi para ajudar você a vender mais, aumentar seu
              faturamento, melhorar seu sell-through, formar equipes de alta performance e transformar sua operação
              em uma máquina de resultados. Acima de tudo, impactar e contribuir para o nosso varejo!
            </p>

            <p className="text-[#b8962e] font-semibold text-base tracking-wide">
              Bem-vindas (os) ao Método CAT.
            </p>
          </div>
        </div>

        {/* Results grid */}
        <div className="border-t border-gray-200 pt-14">
          <p className="text-center text-xs tracking-[0.3em] uppercase text-gray-400 mb-10">
            Resultados gerados ao longo de 28 anos
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {results.map((r) => (
              <div key={r.label} className="flex flex-col items-center text-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#b8962e]/10">
                  <i className={`${r.icon} text-[#b8962e] text-lg`}></i>
                </div>
                <span className="text-2xl font-bold text-black tracking-tight">{r.value}</span>
                <span className="text-xs text-gray-400 leading-tight">{r.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
